import React from 'react';
import advocateProfilePic from '../../../assets/images/advocates-details/nambi.png';

const AdvocateNambiDetails = () => {
  return (
    <section className='team-details'>
      <div className='container'>
        <div className='row justify-content-between'>
          <div className='col-lg-5'>
            <div className='team-details__content'>
              <h2 className='team-details__title'>Read my story</h2>
              <p className='team-details__text'>
                Krishna pursued his LLB from Mahatma Gandhi law College
                affiliated to Osmania University in 2023. Currently pursuing
                his LLM in CRIMINOLOGY AND CRIMINAL JUSTICE SYSTEM from Keshav
                Memorial College of law. He enrolled as an Advocate in the year
                2023. He is Specialized in the areas of civil and criminal laws.
                Currently he is practicing at Hon'ble High Court for the State
                of Telangana, Civil and Criminal Courts in Hyderabad.
              </p>
            </div>
          </div>
          <div className='col-lg-6'>
            <div className='team-one__single'>
              <div className='team-one__image' style={{ textAlign: 'center' }}>
                <img
                  src={advocateProfilePic}
                  alt='Nambi Krishna Dwaipayan'
                  style={{
                    objectFit: 'cover',
                    objectPosition: 'center center',
                    display: 'block',
                    margin: '0 auto',
                    maxWidth: '100%',
                    height: 'auto',
                    border: 'none',
                    outline: 'none',
                    boxShadow: 'none'
                  }}
                />
              </div>
              <div className='team-one__content'>
                <h2 className='team-one__name'>
                  Nambi Krishna Dwaipayan. Btech., LLB
                </h2>
                <p className='team-one__designation'>Advocate</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AdvocateNambiDetails;

